module.exports = __webpack_public_path__ + "static/media/faq-6.41a459de.png";